import React from 'react';
import { 
  MessageCircle, 
  Camera, 
  Calendar,
  Phone
} from 'lucide-react';
import { openSecureUrl, ALLOWED_DOMAINS } from '../../utils/security';

const PhoneCallLink = ({ phoneNumber, className = "" }) => {
  const handlePhoneClick = () => {
    // Limpiar el número para tel: link
    const cleanNumber = phoneNumber.replace(/[^\d+\-\s]/g, '');
    window.location.href = `tel:${cleanNumber}`;
  };

  return (
    <button 
      onClick={handlePhoneClick}
      className={`text-gray-400 hover:text-blue-500 transition-colors ${className}`}
      title={`Llamar a ${phoneNumber}`}
    >
      <Phone className="h-6 w-6" />
    </button>
  );
};

const Footer = ({ 
  currentContent, 
  openWhatsApp, 
  openBooking 
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <img 
              src="/assets/logo-casa-colores-tilcara-hostel.jpg" 
              alt="Casa Colores Hostel Tilcara" 
              className="h-10 w-auto rounded-lg"
            />
            <span className="font-bold text-2xl">Casa Colores</span>
          </div>
          <p className="text-lg text-gray-300 mb-6 font-dancing">
            {currentContent.footer.slogan}
          </p>
          <div className="flex justify-center space-x-6 mb-6">
            <button 
              onClick={openWhatsApp} 
              className="text-gray-400 hover:text-green-500 transition-colors"
            >
              <MessageCircle className="h-6 w-6" />
            </button>
            <PhoneCallLink phoneNumber={currentContent.booking.contact.phone} />
            <button 
              onClick={() => openSecureUrl('https://www.instagram.com/casacolores.hostel', ALLOWED_DOMAINS.INSTAGRAM)} 
              className="text-gray-400 hover:text-pink-500 transition-colors"
            >
              <Camera className="h-6 w-6" />
            </button>
            <button 
              onClick={openBooking} 
              className="text-gray-400 hover:text-blue-500 transition-colors"
            >
              <Calendar className="h-6 w-6" />
            </button>
          </div>
          <p className="text-gray-400 text-sm">
            © {currentYear} {currentContent.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
